import countriesCodes from "../Constants/countriesCodes";
import {getCountries} from "../../Middleware/fetch";
import getVariablesValues from "./getVariablesValues";
import EuropeanUnionFlag from "../../Assets/Images/eu-flag.jpg";
import {VARIABLES_CONTENT} from "../Constants/variables";
import valueFormat from "./valueFormat";

const getTopCountries = async (requestVariables) => {
	let topCountries = [
		{position: 1, name: "", flag: "", variables: []},
		{position: 2, name: "", flag: "", variables: []},
		{position: 3, name: "", flag: "", variables: []},
	];

	// Get top countries and variables values from the API
	const scores = await getCountries(requestVariables);
	const top3 = scores.filter(c => c[0] !== "Colombia").slice(0, 3).map((c) => c[0]);
	const variablesValues = await getVariablesValues(top3, requestVariables);

	// Get the variables list
	let variablesIDs = [];
	Object.keys(requestVariables).forEach((axisName) => {
		if (axisName === "idioma") variablesIDs = [...variablesIDs, ...["Ingles", "Español", "Otros-idiomas"]];
		else variablesIDs = [...variablesIDs, ...requestVariables[axisName]];
	});

	for (let i = 0; i < 3; i++) {
		let countryName = top3[i];

		// Set the name and flag image
		topCountries[i].name = countryName;
		if (countryName === "Unión Europea") topCountries[i].flag = EuropeanUnionFlag;
		else topCountries[i].flag = `https://flagcdn.com/h240/${countriesCodes[countryName][0].toLowerCase()}.png`;

		// Set the variables list
		let countryVariables = [], colombiaVariables = [];
		variablesIDs.forEach((id) => {
			// Set the variable name
			let name = VARIABLES_CONTENT[id].content;
			const languageNames = ["Ingles", "Español", "Otros-idiomas"];
			const eCommerceNames = ["Viajes", "Moda", "Tecnologia", "Alimentos", "Muebles"];
						
			if (languageNames.includes(id)) name = "Idioma";
			else if (eCommerceNames.includes(id)) name = `Gastos eCommerce (${VARIABLES_CONTENT[id].content})`;
			else if (/^Importaciones((?!var).)*$/.test(id)) name = `Importaciones (${VARIABLES_CONTENT[id].content})`;
			else if (/^Importaciones-var/.test(id)) name = `Variación importaciones (${VARIABLES_CONTENT[id].content})`;

			// Set the variable value
			let countryValue = `${valueFormat(variablesValues[countryName][id])} ${VARIABLES_CONTENT[id].units}`;
			let colombiaValue = `${valueFormat(variablesValues["Colombia"][id])} ${VARIABLES_CONTENT[id].units}`;
			
			if (variablesValues[countryName][id] === "-") countryValue = "No especificado";
			if (variablesValues["Colombia"][id] === "-") colombiaValue = "No especificado";
			
			// Add the variable to the list
			if (!(name === "Idioma" && countryValue === "No especificado"))
				countryVariables.push({id: id, name: name, value: countryValue});

			if (!(name === "Idioma" && colombiaValue === "No especificado"))
				colombiaVariables.push({id: id, name: name, value: colombiaValue});
		});

		topCountries[i].variables = [countryVariables, colombiaVariables];
	}

	return topCountries;
};

export default getTopCountries;
